import { getResourceUsage as publicGetResourceUsage } from './cloud-resourceusage-v1-resource-usage-data.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getResourceUsage: MaybeContext<
  BuildRESTFunction<typeof publicGetResourceUsage> &
    typeof publicGetResourceUsage
> = /*#__PURE__*/ createRESTModule(publicGetResourceUsage);

export { CollectionType } from './cloud-resourceusage-v1-resource-usage-data.universal.js';
export {
  ResourceUsage,
  DataCollectionResourceUsage,
  GetResourceUsageRequest,
  GetResourceUsageResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  GetResourceUsageOptions,
} from './cloud-resourceusage-v1-resource-usage-data.universal.js';
export { CollectionTypeWithLiterals } from './cloud-resourceusage-v1-resource-usage-data.universal.js';
